import { Account, cn } from '@liquidbudget/common';
import { AlertTriangleIcon, AsteriskIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { AccountMenu } from '@/components/budget-nav/account-menu';

type AccountNavLinkProps = {
  account: Account;
  to: string;
  text: string;
  indicator?: boolean;
  aside?: string;
  error?: boolean;
};

export function AccountNavLink({ to, text, aside, account, indicator, error = false }: AccountNavLinkProps) {
  const { pathname } = useLocation();

  const linkStyles = error
    ? pathname === to
      ? 'bg-red-200 text-red-900 border border-red-400 dark:bg-red-900/60 dark:text-red-100 dark:border-red-700'
      : 'bg-red-100 text-red-800 border border-red-300 shadow-sm hover:bg-red-200 dark:bg-red-950/40 dark:text-red-200 dark:border-red-800/60 dark:hover:bg-red-900/60'
    : pathname === to
      ? 'bg-primary text-primary-foreground'
      : 'hover:bg-accent hover:text-accent-foreground';

  return (
    <div className="group/item flex items-center space-x-1 w-full">
      <AccountMenu account={account} />

      <Link to={to} className={cn('flex items-center w-full py-2 pl-2 pr-4 rounded-md transition-colors', linkStyles)}>
        <span>{text}</span>
        <span className="flex-grow -ml-1">
          {!error && indicator && <AsteriskIcon className="ml-2  h-3 w-3" />}
          {error && <AlertTriangleIcon className="ml-2 h-3 w-3" />}
        </span>
        {aside && <span className="text-xs tabular-nums">{aside}</span>}
      </Link>
    </div>
  );
}
